import {
  EAccessDataStatus,
  EInvestorAccess,
  EInvestorAccessStatus,
  TFounderInfo
} from "@/frontend/features/Company/model/types/types";

export function getDisplayingDataAccess(founderInfoData: TFounderInfo) {
  const { founderPresent, investorAccess, investorAccessStatus, isDataRoomPending } = founderInfoData || {};

  if (!founderPresent) {
    return EAccessDataStatus.NO_FOUNDER;
  }

  if (
    founderPresent &&
    investorAccessStatus === EInvestorAccessStatus.APPROVED &&
    investorAccess === EInvestorAccess.FULL
  ) {
    return EAccessDataStatus.FULL_DATA;
  }

  if (founderPresent && investorAccessStatus === null) {
    return EAccessDataStatus.NO_ACCESS;
  }

  if (founderPresent && investorAccessStatus === EInvestorAccessStatus.PENDING) {
    return EAccessDataStatus.PENDING_REQUEST;
  }

  if (
    founderPresent &&
    investorAccessStatus === EInvestorAccessStatus.APPROVED &&
    investorAccess === EInvestorAccess.PROFILE
  ) {
    return EAccessDataStatus.PROFILE_DATA;
  }
  return EAccessDataStatus.NO_ACCESS;
}
